var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.611,
    height: 33.611,
    viewBox: "0 0 33.611 33.611",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.578,0H4.033A3.961,3.961,0,0,0,0,4.033V29.578a4,4,0,0,0,4.033,4.033H29.578a4,4,0,0,0,4.033-4.033V4.033A3.961,3.961,0,0,0,29.578,0ZM26.418,12.033H24.8c-1.681,0-2.42.4-2.42,1.613v2.42h4.033L25.611,20.1H22.385V32.132H18.352v-12.1H15.125V16h3.227v-2.42C18.352,10.352,19.965,8,23.124,8a4.932,4.932,0,0,1,3.227.807v3.227Z",
    fill: "#222f3e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.0c22568d2389a02e2b62d6adb1941655.svg";
export { ForwardRef as ReactComponent };